import { Box, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import Iconify from "minimals-template/components/Iconify"

export function UnlockWorkPackageDialog({ scheduleCount = 0 }) {
    const scheduleLabel = scheduleCount === 1 ? "schedule" : "schedules"

    return (
        <DialogBox
            title={
                <Box display="flex" alignItems="center" gap="12px">
                    <Iconify icon="material-symbols:lock-open-outline" />
                    <Typography variant="h5">Unlock Work Package</Typography>
                </Box>
            }
            value={true}
            data-cy="unlock-work-package-dialog"
            okCaption="Unlock & Reopen"
            okIcon="material-symbols:lock-open-outline"
        >
            <Typography mt={2}>
                Reopen this work package for editing in authoring. Approved drafts will return to{" "}
                <Typography component="span" fontWeight={600}>
                    editing
                </Typography>
                .
            </Typography>
            <Typography mt={2}>
                <Typography component="span" fontWeight={600}>
                    {scheduleCount} {scheduleLabel}
                </Typography>{" "}
                already pushed to legacy will stay there. Unlocking only reopens authoring so you can edit and re-send.
            </Typography>
        </DialogBox>
    )
}
